import React from 'react';

import DatePicker from 'react-datepicker';
import { FieldComponent, InputField } from '@jutro/components';
import _ from 'lodash';
import moment from 'moment';
import CommonConstants from 'sg-common-constants';

class SgMonthYearPicker extends FieldComponent {
    static propTypes = {
        ...FieldComponent.propTypes
    }

    constructor(props, context) {
        super(props, context);

        this.state = {
            showMonthPicker: false
        };

        this.datePickerElement = null;
    }

    componentDidMount() {
        const {
            id,
            modelVM,
            path,
            onValidate
        } = this.props;

        if (onValidate) {
            onValidate(_.get(modelVM, path).aspects.valid, id);
        }
    }

    componentDidUpdate(prevData) {
        const {
            id,
            modelVM,
            path,
            onValidate,
            value
        } = this.props;
        const valueChanged = !_.isEqual(value, prevData.value);
        if (onValidate && valueChanged) {
            const isValid = _.get(modelVM, path).aspects.valid;
            onValidate(isValid, id);
        }
        if (this.datePickerElement) {
            this.datePickerElement.removeEventListener('keydown', this.preventTabOutOfPicker);
        }
    }

    componentWillUnmount() {
        const {
            id,
            onValidate,
        } = this.props;
        onValidate(true, id);
        if (this.datePickerElement) {
            this.datePickerElement.removeEventListener('keydown', this.preventTabOutOfPicker);
            this.datePickerElement.removeEventListener('keydown', this.handleKeyboardSelection);
        }
    }

    showErrors() {
        return !_.get(this.props.modelVM, `${this.props.path}.aspects.valid`)
            && (this.state.fieldChanged || this.props.showErrors);
    }

    getValidationMessages() {
        return [_.get(this.props.modelVM, `${this.props.path}.aspects.validationMessage`)];
    }

    onChange = (newValue) => {
        const newDate = {};
        const momentDate = moment(newValue);
        if (!this.state.showMonthPicker) { // year picker
            newDate.year = momentDate.format('YYYY');
            this.setState({
                showMonthPicker: true,
            });
            if (this.datePickerElement) {
                this.datePickerElement.removeEventListener('keydown', this.preventTabOutOfPicker);
            }
        } else {
            newDate.year = momentDate.format('YYYY');
            newDate.month = newValue.getMonth();
            newDate.monthViewValue = momentDate.format('MM');
            this.focusOnFirstSelectableElement();
        }
        this.props.writeValue(newDate);
    }

    handleAccessibilityOnOpen = () => {
        this.focusOnFirstSelectableElement();
        if (!this.state.showMonthPicker) {
            this.datePickerElement.addEventListener('keydown', this.preventTabOutOfPicker);
        }
        this.datePickerElement.addEventListener('keydown', this.handleKeyboardSelection);
    }

    preventTabOutOfPicker = (e) => {
        if (e.key === CommonConstants.EVENT_KEYS.TAB_KEY) {
            e.preventDefault();
        }
    }

    handleKeyboardSelection = (e) => {
        if (e.key === CommonConstants.EVENT_KEYS.ENTER_KEY || e.which === CommonConstants.EVENT_KEYS.SPACEBAR_CODE) {
            e.preventDefault();
            e.target.click();
        }
    }

    focusOnFirstSelectableElement = () => {
        // eslint-disable-next-line prefer-destructuring
        this.datePickerElement = document.getElementsByClassName('react-datepicker-popper')[0];
        const firstSelectableDate = this.datePickerElement.querySelectorAll('div[tabindex="0"]')[0];
        firstSelectableDate.focus();
    }

    renderControl() {
        const {
            customId
        } = this.props;
        if (this.datePickerElement) {
            this.datePickerElement.removeEventListener('keydown', this.preventTabOutOfPicker);
        }
        const dynamicProps = {};
        if (this.props.maxDate) {
            if (this.state.showMonthPicker) {
                dynamicProps.maxDate = moment(this.props.maxDate).endOf('month').toDate();
            } else {
                dynamicProps.maxDate = moment(this.props.maxDate).endOf('year').toDate();
            }
        }
        if (this.props.minDate) {
            if (this.state.showMonthPicker) {
                dynamicProps.minDate = moment(this.props.minDate).startOf('month').toDate();
            } else {
                dynamicProps.minDate = moment(this.props.minDate).startOf('year').toDate();
            }
        }

        const DateInput = ({
            className, onChange, placeholder, value, id, onClick
        }) => {
            const onKeyboardClick = (e) => {
                e.preventDefault();
                if (e.key !== CommonConstants.EVENT_KEYS.TAB_KEY) {
                    onClick();
                }
            };

            return (
                <div
                    role="button"
                    tabIndex="0"
                    onClick={onClick}
                    onKeyPress={onKeyboardClick}
                >
                    <InputField
                        className="sgDatePickerMargin"
                        controlClassName={className}
                        onValueChange={onChange}
                        placeholder={placeholder}
                        value={value}
                        id={id}
                    />
                </div>
            );
        };
        return (
            <DatePicker
                id={`${customId}_monthYearPicker`}
                selected={this.props.value}
                onChange={this.onChange}
                showYearPicker={!this.state.showMonthPicker}
                showMonthYearPicker={this.state.showMonthPicker}
                yearItemNumber={12}
                placeholderText="mmm yyyy"
                dateFormat="MMM yyyy"
                customInput={<DateInput />}
                onCalendarOpen={this.handleAccessibilityOnOpen}
                shouldCloseOnSelect={this.state.showMonthPicker}
                {...dynamicProps}
            />
        );
    }

    render() {
        return super.render();
    }
}

export default SgMonthYearPicker;
